import { AccountTypes, ButtonActionType } from '@finxone-platform/shared/sys-config-types';

export function isDataContextApplicable(action: ButtonActionType | undefined): boolean {
  const actionsThatShowDataContext: ButtonActionType[] = [
    ButtonActionType.CHANGE_ACCOUNT_NICKNAME,
    // Add more actions here in the future
  ];

  return action ? actionsThatShowDataContext.includes(action) : false;
}

export function dataContextOption(action: ButtonActionType | undefined): {
  label: string;
  value: AccountTypes;
}[] {
  if (!action) return [];

  switch (action) {
    case ButtonActionType.CHANGE_ACCOUNT_NICKNAME:
      return [
        { label: 'Current', value: AccountTypes.CURRENT_ACCOUNT },
        { label: 'Saving', value: AccountTypes.SAVINGS_ACCOUNT },
      ];
    // Add more actions options here in the future
    default:
      return [];
  }
}
